import { Component, Optional, inject } from '@angular/core';
import { DokItemInfo } from '@app/components/dokumentacija/dokumentacija-types';
import { INITAL_ROOT_VIEWSTATE } from '@app/components/hierarhija/hierarhija.component';
import { ParentListViewProvider } from '@app/components/pretraga-kataloga/providers/parent-list-view.provider';
import { TreeViewProviderDirective } from '@app/providers';
import { DynamicFormService } from '@ntap/common';
import {
  BusinessItem,
  DataSource,
  ItemActionResult,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { PrimeNGButtonDeleteItemActionComponent } from '@ntap/primeng';
import { ConfirmationService } from 'primeng/api';
import { Observable, map, tap } from 'rxjs';

@Component({
  selector: 'app-obrisi-dok-jedinica-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class ObrisiDokumentacijaJedinicaListItemActionComponent extends PrimeNGButtonDeleteItemActionComponent {
  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional() protected override dynamicFormService: DynamicFormService,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    protected override confirmationService: ConfirmationService
  ) {
    super(
      notificationService,
      itemProvider,
      dataSource,
      dynamicFormService,
      listViewProvider,
      confirmationService
    );
  }

  private parentListView = inject(ParentListViewProvider);

  protected override initDisabledObservable(): void {
    super.initDisabledObservable();
    this.isDisabled$ = this.itemProvider.item$.pipe(
      map((item) => {
        const dokInfo = new DokItemInfo(item);
        return this.isDisabled(dokInfo);
      })
    );
  }

  protected isDisabled(dokInfo: DokItemInfo): boolean {
    return (
      dokInfo.permission < 2 || this.action.disabled || dokInfo.locked === true
    );
  }

  protected override doExecuteWithItem(
    item: object
  ): Observable<ItemActionResult> {
    return super.doExecuteWithItem(item).pipe(
      tap(() => {
        const bi = new BusinessItem(item);
        if (this.listViewProvider instanceof TreeViewProviderDirective) {
          const parentJedinicaId =
            bi.data['en~jedinica_gradiva~nadredena_jedinica_gradiva'];
          if (!parentJedinicaId) {
            // root node
            const initialRootViewState = Object.assign(INITAL_ROOT_VIEWSTATE);
            this.listViewProvider.rootViewState = initialRootViewState;
          } else {
            this.listViewProvider.refreshNodeParent(bi.id);
          }
        } else if (this.parentListView instanceof TreeViewProviderDirective) {
          this.parentListView.refreshNodeParent(bi.id);
        }
      })
    );
  }
}
